import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import "./style.css";

interface CustomMenuPopoverProps {
    onClose: Function;
    items: {
        id: string | number;
        label: React.ReactNode | string;
        disabled?: boolean;
    }[];
    onSelectItem: Function;
    position: { left: number; top: number };
    visible: boolean;
}

export const CustomMenuPopover = ({
    onClose,
    items,
    onSelectItem,
    position,
    visible,
}: CustomMenuPopoverProps) => {
    const wrapperRef = useRef(null);

    // Needed to close the menu on click outside
    useEffect(() => {
        function handleClickOutside(event: any) {
            if (
                wrapperRef.current &&
                !(wrapperRef.current! as any).contains(event.target)
            ) {
                onClose();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef, onClose]);

    function selectItem(id: string | number, disabled?: boolean) {
        if (!disabled) {
            onSelectItem(id);
        }
    }

    return visible ? (
        <div className="c-CustomMenuPopover" ref={wrapperRef}>
            <div>
                <div
                    className="c-CustomMenuPopover-dropdown"
                    style={{ left: position.left, top: position.top + 25 }}
                >
                    <div className="c-CustomMenuPopover-dropdown-arrow"></div>
                    <ul className="c-CustomMenuPopover-dropdown-menu">
                        {items.map((item) => (
                            <li
                                className={classNames(
                                    "c-CustomMenuPopover-dropdown-menu-item",
                                    item.disabled
                                        ? "c-CustomMenuPopover-dropdown-menu-item-disabled"
                                        : undefined
                                )}
                                onClick={() =>
                                    selectItem(item.id, item.disabled)
                                }
                            >
                                <span
                                    className={classNames(
                                        "c-CustomMenuPopover-dropdown-menu-item-label",
                                        item.disabled
                                            ? "c-CustomMenuPopover-dropdown-menu-item-label-disabled"
                                            : undefined
                                    )}
                                >
                                    {item.label}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    ) : null;
};
